import { LightModeSemanticColors } from '@enechain/ecloud-designsystem'

/**
 * Recharts の左 Y 軸目盛りを「カード左端始まりで左寄せ」描画する tick。
 *
 * 既定の右寄せ (軸線基準・textAnchor="end") だと、需要チャートの 5〜6 桁 MWh
 * 目盛り (例: 16,000) がカード左端からはみ出し、チャートカードの overflow:hidden
 * でラベル先頭が見切れる。そこで先頭をカード左端 (x=2) に固定して内側 (プロット
 * 方向) へ伸ばす左寄せにし、桁数に依らず見切れないようにする。整数丸め +
 * 桁区切りは需要 (MWh) / 気温 (℃) 双方に無害なので共通化している。
 *
 * margin.left=0 前提 (tick の x はチャート SVG の絶対座標なので、負の左マージンを
 * 併用すると左端がずれる)。呼び出し側は `<YAxis tick={<LeftAlignedYAxisTick />} />`
 * の element 形で渡す (Recharts が x/y/payload を cloneElement で注入する)。
 *
 * `fontSize={11}` は SVG の presentation 属性になるが、Chakra preflight の
 * `"*": { font: "inherit" } ` に負けて効かない (Supply48DataChart.tsx と同じ罠)。
 * 呼び出し元 (DetailChart / WeatherChart) が css `.recharts-text { fontSize }` で
 * 上書きする前提のため、ここで `className="recharts-text"` を明示する — Recharts
 * 内蔵の tick (`component/Text.js`) は自動でこの class を持つが、本 component は
 * 生 `<text>` を描くため (かつ Recharts が cloneElement で注入する className prop は
 * ここで受け取っていないため) 明示しないと selector が届かない。
 */
export const LeftAlignedYAxisTick = ({
  y,
  payload,
}: {
  y?: number
  payload?: { value: number }
}): React.ReactElement => (
  <text
    className="recharts-text"
    fill={LightModeSemanticColors.Text.midEmphasis.value}
    fontSize={11}
    dy={3}
    textAnchor="start"
    x={2}
    y={y}
  >
    {payload !== undefined ? Math.round(payload.value).toLocaleString() : ''}
  </text>
)
